module.exports = __webpack_public_path__ + "static/media/dog-leashed.9c72642c.svg";